import { Expose, Transform, Type } from 'class-transformer';
import { UserGender, UserType } from '../../common';
import { formatMobileNumber } from 'src/app/shared/helper';
import { DropdownModel } from './dropdown-model';
import { UserDevicesModel } from './user-devices-model';
import { NameTranslationsModel } from './name-translation-model';

export class BasicUser extends DropdownModel {
  @Expose() id: string;
  @Expose() fullName: string;
  @Expose() userId?: string;
  @Expose() email: string;
  @Expose() username: string;
  @Expose()
  @Transform(({ value }) => {
    return transformGender(value);
  })
  gender: UserGender;
  @Expose() avatarUrl?: string;
  @Expose() city?: string;
  @Expose() country?: string;
  @Expose() address?: string;
  @Expose() type: UserType;

  // since basic user uses transformed version of phone, we need to keep the original phone
  @Expose()
  @Transform(({ obj }) => obj.phone)
  originalPhone: string;
  @Expose()
  @Transform(({ value }) => (value ? formatMobileNumber(value) : null))
  phone?: string;
  @Expose()
  @Type(() => UserDevicesModel)
  devices: UserDevicesModel;
  @Expose() hasCategories: boolean = false;
  @Expose() whiteLabelDashboardLogoURL: string;
  @Expose() appName: string;
  @Expose() parent: string;
  @Expose()
  @Type(() => NameTranslationsModel)
  nameTrans: NameTranslationsModel;

  override get dropDownDisplayName(): string {
    return this.fullName;
  }
  override get dropDownValue(): Object {
    return this;
  }
}

function transformGender(gender: string): string {
  if (gender == 'ذكر') {
    return UserGender.MALE;
  } else if (gender == 'أنثى') {
    return UserGender.FEMALE;
  }
  return gender;
}
